import MultiSelect from "@/components/MultiSelect";

type GovernanceOrgTypeFilterProps = {
  name: string;
  options: { value: string; label: string }[];
  selectedValues: string[];
  onSelect: (value: string, checked: boolean) => void;
  onClear: () => void;
};

export function GovernanceOrgTypeFilter({
  name,
  options,
  selectedValues,
  onSelect,
  onClear
}: GovernanceOrgTypeFilterProps) {
  if (options.length < 2) {
    return null;
  }

  return (
    <div data-name={name}>
      <MultiSelect
        label="Type"
        options={options}
        selectedValues={selectedValues}
        onSelect={onSelect}
        onClear={onClear}
      />
    </div>
  );
}
